import React from 'react';
import { Button } from 'reactstrap';

function ChatMsgRendererAdmin({ item, onReciveButtonClick = () => null }) {
  return (
    <>
      {item.sentBy === 'admin' ? (
        <div class='chatBotWidget-message'>
          <div class='chatBotWidget-clientMsg'>
            <div class='chatBotWidget-client_txt'>
              <p style={{ color: 'black' }}>{item.text}</p>
            </div>
          </div>
        </div>
      ) : (
        <div class='chatBotWidget-message'>
          <img
            src={require('assets/img/anime3.png')}
            class='chatBotWidget-avatar'
            alt='profile'
          />
          <div class='chatBotWidget-response'>
            <div class='chatBotWidget-client_txt'>
              <p style={{ color: 'black' }}>{item.text}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ChatMsgRendererAdmin;
